module.exports = __webpack_public_path__ + "img/usa-respiratory-diseases-male.bd479f1b.png";